<template>
  <div>
    <div>
      <div>
        <iframe
          width="40%"
          height="80px"
         :src="src1"
          frameborder="0"
          scrolling="no"
          sandbox="allow-scripts allow-same-origin"
        ></iframe>
      </div>
      <div>
        <iframe
          width="100%"
          height="350"
          :src="src2"
          scrolling="yes"
          frameborder="0"
          sandbox="allow-scripts allow-same-origin"
        ></iframe>
      </div>
      <div>
        <iframe
          width="100%"
          height="1000px"
          :src="src3"
          scrolling="yes"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    </div>
</template>
  <script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Visitors",
  components: {  },
  data() {
    return { 
      src1:"http://"+this.$store.state.baseurl+":10081/index.php?module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=CoreVisualizations&actionToWidgetize=singleMetricView&idSite=1&period=day&date=yesterday",
      src2:"http://"+this.$store.state.baseurl+":10081/index.php?module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=UserCountry&actionToWidgetize=getCity&idSite=1&period=day&date=yesterday",
      src3:"http://"+this.$store.state.baseurl+":10081/index.php?module=Widgetize&action=iframe&containerId=VisitOverviewWithGraph&disableLink=1&widget=1&moduleToWidgetize=CoreHome&actionToWidgetize=renderWidgetContainer&idSite=1&period=day&date=yesterday",
    
    };
  },
  mounted: function () {
    this.$nextTick(function () {});
  },
  created() {},
  methods: {},
};
</script>
  <style scoped>
</style>